import React from "react";
import { JumpToPageIcon } from "./utils";

const getConfidenceColor = confidence => {
  if (!confidence) return "black";
  if (confidence > 85) return "green";
  if (confidence > 72) return "#ba5a17";
  return "red";
};

export const extractedValuesAppend = (fn, confidence, pageNumber) => {
  const response = [];
  confidence && response.push(<p style={{ margin: 0, color: getConfidenceColor(confidence) }}>{confidence}%</p>);
  pageNumber && response.push(<JumpToPageIcon fn={fn} page={Math.max(0, pageNumber - 1)} />);
  return response;
};
